import { darken, transparentize } from 'polished';
import colors from './colors';

const baseTheme = {
  radius: `5px`,
  outlineFocused: `rgba(255,255,255,.9)`,
  outlineUnfocused: `rgba(0,0,0,.9)`,
  divider: `rgba(255,255,255,.05)`,
  primary: colors.primary,
  secondary: colors.secondary
};

const backgroundSemiTransparent = transparentize(0.2, colors.dark);
const backgroundDark = darken(0.08, colors.dark);
const backgroundDarkSemiTransparent = transparentize(0.2, backgroundDark);

const siteThemes = {
  dark: {
    ...baseTheme,
    background: colors.dark,
    backgroundSemiTransparent,
    backgroundDark,
    backgroundDarkSemiTransparent,
    text: colors.light,
    subtleText: transparentize(0.4, colors.light),
    link: {
      color: colors.light
    }
  },
  light: {
    ...baseTheme,
    background: colors.light,
    text: colors.dark
  }
};

const siteTheme = mode => {
  if (siteThemes[mode]) {
    return siteThemes[mode];
  }
  return siteThemes.light;
};

export default siteTheme;
